import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { BerthLookups } from './model';
import { BerthLookupsView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function BerthLookupsRoute(model : BerthLookups, appWrapper : AppWrapper) : IRoute {
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <BerthLookupsView model={model} />
            </AppWrapperView>
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/berthlookups/route.tsx